import {Modal} from '@components/Modal';
import {Typography} from '@components/Typography';
import {Icon} from '@components/Icon';
import {FC, useCallback, useMemo} from 'react';
import {FormattedMessage} from 'react-intl';
import {getGraphQlLocale} from '../../types/graphql/general';
import {useLocale} from '@utils/locale';
import {useAccountPackagesQuery} from '@gql/query/package/account.gql';
import {useSession} from 'next-auth/react';
import {Payment} from '@liveComponents/Payment/Payment';
import {OrderPackageReferenceType} from '.cache/__types__';
import {useAuthorizedUserLazyQuery} from '@gql/query/user/authUser.gql';
import {useUser} from "@utils/user";

export type PremiumPaymentModalProps = {
    show: boolean;
    onHide: () => any;
    lead: React.ReactNode;
    text: React.ReactNode;
};

export const PremiumPaymentModal: FC<PremiumPaymentModalProps> = ({show, onHide, lead, text}) => {
    const locale = useLocale();
    const {user, refetch} = useUser();

    const {data: premiumData} = useAccountPackagesQuery({
        variables: {
            locale: getGraphQlLocale(locale),
        },
    });

    const handleSuccess = useCallback(() => {
        refetch(); // Refresh auth user data
    }, [refetch]);

    const premiumPackage = useMemo(() => premiumData?.packageList?.at(0), [premiumData]);

    if (!premiumPackage?.price || !premiumPackage?.currency || !premiumPackage.uri) {
        return null;
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton closeLabel="Zavřít">
                <Modal.Title>
                    <Typography as="h2" variant="subheadline" className="mb-0">
                        <FormattedMessage defaultMessage={'Premium profil'} />
                    </Typography>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Typography as="p" textAlign="center" color="grey-dark" className="mb-8">
                    <Icon.Star size="xxl" />
                </Typography>

                <Typography as="h3" textAlign="center" className="mb-8">
                    {lead}
                </Typography>

                <Typography as="p" textAlign="center" className="mb-8">
                    {text}
                </Typography>

                <Payment
                    currency={premiumPackage.currency}
                    price={premiumPackage.price}
                    packages={[
                        {
                            uri: premiumPackage.uri,
                            price: premiumPackage.price,
                            currency: premiumPackage.currency,
                            referenceId: user?.id ?? '',
                            referenceType: OrderPackageReferenceType.User,
                        },
                    ]}
                    onSuccess={handleSuccess}
                />
            </Modal.Body>
        </Modal>
    );
};
